// @flow

import type {Language, GraphData, PortfolioNotificationEvent} from '../types'

import React from 'react'
import {connect} from 'react-redux'
import {appSelectors} from '@/store'
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import customTooltip from './tooltip'
import {getEvents} from '../store/util'
import {selectThemeColours} from '@/theme-colours'
import {getSessionPartnerId} from '@/partnerID'

type Props = {
  l: Language,
  themeColour: string,
  data: Array<GraphData>,
  title: string,
  notifications: Array<PortfolioNotificationEvent>,
  updateFilteredData: Function,
}

const RawBarChart = (props: Props) =>
  <div>
    <h4>{props.title}</h4>
    <ResponsiveContainer height={250} width="100%">
      <BarChart
        width={900}
        height={150}
        margin={{top: 20, right: 0, left: -20, bottom: 20}}
        data={props.data}
        onClick={getEvents(props.notifications, props.updateFilteredData)}
      >
        <XAxis dataKey="key" label={{value: props.l('Event dates'), position: 'insideBottom', offset: -10}}/>
        <YAxis dataKey="value" label={{value: props.l('Number of events'), angle: -90}}/>
        <CartesianGrid stroke="#ccc" />
        <Tooltip content={customTooltip(props.l('Events'))}/>
        <Bar
          type="linear"
          dataKey="value"
          fill={props.themeColour}
          isAnimationActive={true}
        />
      </BarChart>
    </ResponsiveContainer>
  </div>

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
  themeColour: selectThemeColours(getSessionPartnerId()).primaryColour,
})

export default connect(
  mapStateToProps,
)(RawBarChart)



// WEBPACK FOOTER //
// ./src/elements/bar-chart.js